const FALLBACK_AVG_CHAR_WIDTH_PX = 10;

export const measureTextWidth = (text: string, font: string): number => {
  if (!text) return 0;

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (ctx) {
    ctx.font = font;
    return ctx.measureText(text).width;
  }

  return text.length * FALLBACK_AVG_CHAR_WIDTH_PX;
};

export const getWidestLabelWidth = (labels: string[], font: string): number => {
  if (labels.length === 0) return 0;
  return Math.max(...labels.map((label) => measureTextWidth(label, font)));
};
